import React, { useEffect, useState, useRef, useCallback } from "react";
import "./login-page.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import axios from "axios";
import OtpInput from "react-otp-input";
import { useDispatch } from "react-redux";
import {
  populateStateWithUserDetails,
  updateLeadId,
  updateUserPhone,
} from "../../features/userDetailsSlice";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Button } from "@mui/material";
import CustomTimer from "../../components/CustomTimer";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import { updateDoctorID } from "../../features/calendarWidgetSlice";

const LoginPage = () => {
  let navigate = useNavigate();
  const [otp, setOtp] = useState("");
  const [apiOtp, setApiOtp] = useState("");
  const [phone, setPhone] = useState("");
  const [isLeadExists, setIsLeadExists] = useState(false);
  const [currentUid, setCurrentUid] = useState("");
  const [isPhoneSubmitted, setIsPhoneSubmitted] = useState(false);
  const [timer, setTimer] = useState("-:--");
  const [remaingTime, setRemaingTtime] = useState(120);
  const [startTimers, setStartTimer] = useState(0);
  const [invalidOtpStatus, setInvalidOtpStatus] = useState(false);
  const [hojaUpdate, setHojaUpdate] = useState("");
  const dispatch = useDispatch();

  const [searchParams, setSearchParams] = useSearchParams();
  const doctorId = Number(searchParams.get("doctorId"));
  // console.log(typeof doctorId, "fffff");

  dispatch(updateDoctorID({ doctorId: doctorId }));

  const phoneInputForm = useRef();
  const otpForm = useRef();

  /**
   *  @description utility objects and functions required for making login request
   *  @func uid()
   *  @returns a random string of length 16
   */
  const loginRequestUtils = {
    uid: () => {
      var randomString = "";
      var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz1234567890";
      for (var i = 0; i <= 16; i++) {
        var rnum = Math.floor(Math.random() * characters.length);
        randomString += characters.substring(rnum, rnum + 1);
      }
      return randomString;
    },
  };

  /**
   *  @description request config for login request
   *  @params
   *  - phone_number => users phone number
   *  - uid => random string of length 16
   *  - type => login (for logging in the existing user) / signup (for signing up the new users)
   */
  var loginRequestData = null;
  // let toastShown = false;
  if (phone && phone.length > 0) {
    loginRequestData = {
      url: `${
        process.env.REACT_APP_API_ENDPOINT
      }/crm_lead/login?phone_number=${phone.slice(
        -10
      )}&uid=${loginRequestUtils.uid()}&type=login`,
      method: `POST`,
      params: {
        country_code: phone.substring(1, phone.length - 10),
      },
    };
  } else if (phone) {
    // Check if phone is truthy but length is 0 (empty string)
    toast.error("Invalid phone number", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  }

  const signUpAction = async () => {
    const signupRequestUtils = {
      uid: () => {
        var randomString = "";
        var characters =
          "ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz1234567890";
        for (var i = 0; i <= 16; i++) {
          var rnum = Math.floor(Math.random() * characters.length);
          randomString += characters.substring(rnum, rnum + 1);
        }
        return randomString;
      },
    };

    /**
     *  @description request config for signup POST request
     *  @params
     *  - phone_number => users phone number
     *  - uid => random string of length 16
     *  - type => login (for logging in the existing user) / signup (for signing up the new users)
     *  - country code => user phone number country code
     */
    const signUpRequestData = {
      url: `${
        process.env.REACT_APP_API_ENDPOINT
      }/crm_lead/login?phone_number=${phone?.slice(
        -10
      )}&uid=${signupRequestUtils.uid()}&type=signup`,
      method: `POST`,
      params: {
        country_code: phone.substring(1, phone.length - 10),
      },
    };

    const oauthParams = {
      consumer_key: process.env.REACT_APP_CONSUMER_KEY,
      consumer_secret: process.env.REACT_APP_CONSUMER_SECRET,
      token: process.env.REACT_APP_TOKEN,
      token_secret: process.env.REACT_APP_TOKEN_SECRET,
      timestamp: Math.floor(Date.now() / 1000),
      nonce: Math.random()?.toString(36)?.substring(2),
    };

    const signature = `${process.env.REACT_APP_CONSUMER_SECRET}&${process.env.REACT_APP_TOKEN_SECRET}`;
    const headers = {
      Authorization: `OAuth oauth_consumer_key="${
        oauthParams.consumer_key
      }", oauth_token="${
        oauthParams.token
      }", oauth_signature_method="PLAINTEXT", oauth_timestamp="${
        oauthParams.timestamp
      }", oauth_nonce="${
        oauthParams.nonce
      }", oauth_version="1.0", oauth_signature="${encodeURIComponent(
        signature
      )}"`,
    };

    try {
      const response = await axios({
        url: signUpRequestData.url,
        method: signUpRequestData.method,
        params: signUpRequestData.params,
        headers,
      });

      // console.log(response);
      const signUpOtp = response.data.OTP;
      dispatch(updateUserPhone({ phoneNumber: phone }));
      return signUpOtp;
    } catch (error) {
      // console.log(`error in sign up API 👉 ${error}`);
    }
  };

  /**
   *  @description request config to get OTP for validation of OTP entered by the user for login action
   *  @params
   *  phone_number -> users phone number
   *  uid -> random string of length 16
   */
  var OTPRequestData = null;
  if (phone && phone.length > 0) {
    OTPRequestData = {
      url: `${
        process.env.REACT_APP_API_ENDPOINT
      }/crm_lead/send_otp?phone_number=${
        phone && phone.length > 0 ? phone.slice(-10) : ""
      }&uid=${currentUid}`,
      method: `POST`,
      params: {
        country_code: phone.substring(1, phone.length - 10),
      },
    };
  } else if (phone) {
    // Check if phone is truthy but length is 0 (empty string)
    toast.error("Invalid phone number", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsPhoneSubmitted(true);

    const oauthParams = {
      consumer_key: process.env.REACT_APP_CONSUMER_KEY,
      consumer_secret: process.env.REACT_APP_CONSUMER_SECRET,
      token: process.env.REACT_APP_TOKEN,
      token_secret: process.env.REACT_APP_TOKEN_SECRET,
      timestamp: Math.floor(Date.now() / 1000),
      nonce: Math.random().toString(36).substring(2),
    };

    const signature = `${process.env.REACT_APP_CONSUMER_SECRET}&${process.env.REACT_APP_TOKEN_SECRET}`;
    const headers = {
      Authorization: `OAuth oauth_consumer_key="${
        oauthParams.consumer_key
      }", oauth_token="${
        oauthParams.token
      }", oauth_signature_method="PLAINTEXT", oauth_timestamp="${
        oauthParams.timestamp
      }", oauth_nonce="${
        oauthParams.nonce
      }", oauth_version="1.0", oauth_signature="${encodeURIComponent(
        signature
      )}"`,
    };

    /**
     * @description fetch lead details || confirm whether the user exists or not!
     * truthy - continue with the otp api
     * falsy - redirect to sign up page
     */
    axios({
      url: `${
        process.env.REACT_APP_API_ENDPOINT
      }/restapi/1.0/object/crm.lead?domain=[('caller_mobile', '=','${phone?.slice(
        -10
      )}')]&fields=['caller_mobile','partner_name','contact_name','caller_email']`,
      method: "GET",
      params: {},
      headers,
    })
      .then((response) => {
        if (response.data["crm.lead"]) {
          setIsLeadExists(true);
          dispatch(
            populateStateWithUserDetails({
              phoneNumber: response?.data["crm.lead"]?.caller_mobile,
              fullName: response?.data["crm.lead"]?.contact_name,
              emailAddress: response?.data["crm.lead"]?.caller_email,
            })
          );

          /**
           * @description Login API Call
           */
          axios({
            url: loginRequestData.url,
            method: loginRequestData.method,
            params: loginRequestData.params,
          })
            .then((response) => {
              if (response?.data?.success) {
                // console.log(response?.data);
                setCurrentUid(response?.data?.uid);
                console.log("id", response?.data?.lead_id);
                let leadId = response?.data?.lead_id;
                dispatch(updateLeadId({ leadId: leadId }));

                /**
                 * ----------------------------------------------------------------------------
                 * @description send OTP after login
                 * ----------------------------------------------------------------------------
                 */
                axios({
                  url: `${
                    process.env.REACT_APP_API_ENDPOINT
                  }/crm_lead/send_otp?phone_number=${phone.slice(-10)}&uid=${
                    response?.data?.uid
                  }&country_code=${phone.substring(1, phone.length - 10)}`,
                  method: OTPRequestData.method,
                  params: OTPRequestData.params,
                })
                  .then((response) => {
                    let otpFromAPI = response.data.OTP;
                    otpFromAPI.toString();
                    setApiOtp(otpFromAPI);
                    // console.log(response.data);
                  })
                  .catch((error) => {
                    console.error("Error is ____________", error);
                  });
              } else {
                signUpAction()
                  .then((otp) => {
                    // console.log("returned otp from sign up action : " + otp);
                    otp.toString();
                    setApiOtp(otp);
                  })
                  .catch((error) => {
                    console.error(error);
                  });
              }
            })
            .catch((error) => {
              // console.log(error);
            });
        }
      })
      .catch((err) => {
        // console.log("Lead does not exists", err);
        if (err?.response?.data?.code === 404) {
          signUpAction()
            .then((otp) => {
              // console.log("returned otp from sign up action : " + otp);
              otp = otp.toString();
              setApiOtp(otp);
            })
            .catch((error) => {
              console.error(error);
            });
        }
      });
  };

  const handleOTPSubmit = (otp) => {
    // console.log("inside handle function");
    if (isLeadExists) {
      if (otp !== "" && apiOtp !== "") {
        // console.log(`user: ${otp}, api: ${apiOtp} ${typeof +otp + typeof apiOtp}`);
        if (+otp === apiOtp) {
          // console.log("about to navigate to services-for");
          navigate(`/service-for`);
        } else {
          setInvalidOtpStatus(true);
        }
      }
    } else {
      if (otp !== "" && apiOtp !== "") {
        // console.log(`user: ${otp}, api: ${apiOtp}`);
        if (otp === apiOtp) {
          navigate(`/user-details`);
        } else {
          setInvalidOtpStatus(true);
        }
      }
    }
    // console.log(otp)
    // setTimeout(setInvalidOtpStatus(false), 5000);
  };

  return (
    <div className="login-page">
      <h2>Tell us a little bit about you?</h2>
      <div className="login-page__form__wrapper">
        <form
          className="login-page__phone-input"
          ref={phoneInputForm}
          onSubmit={(e) => handleSubmit(e)}
        >
          <label>Mobile Number*</label>
          <div className="country-code-input">
            <PhoneInput
              placeholder="Enter phone number"
              defaultCountry="IN"
              onChange={setPhone}
              value={phone}
            />
          </div>
          <button
            type="submit"
            className={
              isPhoneSubmitted
                ? `login-page__submit-btn__success`
                : `login-page__submit-btn`
            }
            disabled={!(phone && phone.length > 0) || isPhoneSubmitted}
          >
            {isPhoneSubmitted ? "Submitted" : "Log in"}
          </button>
        </form>
        {isPhoneSubmitted && (
          <div className="OTP-input">
            <span>Enter the OTP sent to your phone number</span>
            {/* <form ref={otpForm} onSubmit={(e) => handleOTPSubmit(e)}> */}
            <form ref={otpForm}>
              <OtpInput
                value={otp}
                inputType="tel"
                isInputNum={true}
                onChange={(event) => {
                  setInvalidOtpStatus(false);
                  setOtp(event);
                  // console.log(otp);
                  if (event.length === 4) {
                    handleOTPSubmit(event);
                  }
                }}
                numInputs={4}
                renderInput={(props) => <input {...props} />}
              />
              {/* {console.log(otp)} */}
              {/* {console.log(typeof apiOtp, "apitooo")} */}
            </form>
            {invalidOtpStatus && (
              <p
                style={{
                  color: "red",
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                }}
              >
                <ReportProblemOutlinedIcon /> Invalid OTP!
              </p>
            )}
            {apiOtp ? (
              <div
                className="otp-timer"
                style={{ display: "flex", marginTop: "24px" }}
              >
                {timer === "0:00" ? null : (
                  <CustomTimer
                    timer={timer}
                    starttime={120}
                    setTimer={setTimer}
                    startTimers={startTimers}
                  />
                )}

                <Button
                  color="primary"
                  variant="text"
                  onClick={handleSubmit}
                  disabled={timer !== "0:00"}
                >
                  <u>Resend OTP</u>
                </Button>
              </div>
            ) : null}
          </div>
        )}

        <ToastContainer />
      </div>
    </div>
  );
};

export default LoginPage;
